<template>
    <MainContainer :hideSidebar="true">
        <section class="settings">
            <h2>Einstellungen</h2>
            <SettingSection
                id="settings-lang"
                label="Spracheinstellungen"
                labelFor="setting-lang-select"
            >
                <b-form-select
                    v-model="settings.lang"
                    :options="options.lang"
                    :size="settings.size"
                    :disabled="true"
                    id="setting-lang-select"
                    @change="onChange"
                />
            </SettingSection>
            <SettingSection
                id="settings-display-size"
                label="Darstellungsoptionen"
                labelFor="setting-display-size-select"
            >
                <b-form-select
                    v-model="settings.size"
                    :options="options.size"
                    :size="settings.size"
                    id="setting-lang-select"
                    @change="onChange"
                />
            </SettingSection>
            <SettingSection
                id="settings-display-size"
                label="Gesetzte Filter dauerhaft speichern?"
                labelFor="setting-persistent-filter-select"
            >
                <b-form-select
                    v-model="settings.persistentFilterStoring"
                    :options="options.persistentFilterStoring"
                    :size="settings.size"
                    id="setting-persistent-filter-select"
                    @change="onChange"
                />
            </SettingSection>
        </section>
    </MainContainer>
</template>

<script>
import MainContainer from "@/components/MainContainer/MainContainer";
import SettingSection from "@/components/SettingSection/SettingSection";
export default {
    name: "settings",
    components: {
        MainContainer,
        SettingSection
    },
    data() {
        return {
            settings: {
                lang: null,
                size: null,
                persistentFilterStoring: false
            },
            options: {
                lang: [
                    { value: null, text: "Automatisch" },
                    { value: "de", text: "Deutsch" },
                    { value: "en", text: "English" }
                ],
                size: [
                    { value: "sm", text: "klein" },
                    { value: "", text: "normal" },
                    { value: "lg", text: "groß" }
                ],
                persistentFilterStoring: [
                    { value: true, text: "Ja" },
                    { value: false, text: "Nein" }
                ]
            }
        };
    },
    created() {
        this.getSettings();
    },
    methods: {
        getSettings() {
            this.settings = this.$store.getters.getSettings;
        },
        onChange(evt) {
            this.$store.dispatch("settings", this.settings);
        }
    }
};
</script>